import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SeOverlayComponent } from './se-overlay/se-overlay.component';
import { SePopupComponent } from './se-popup/se-popup.component';
import { SePopupContentComponent } from './se-popup-content/se-popup-content.component';

@NgModule({
  imports: [
    CommonModule,
    // MatIconModule
  ],
  exports: [
      SeOverlayComponent,
      SePopupComponent,
      SePopupContentComponent
  ],
  declarations: [
      SeOverlayComponent,
      SePopupComponent,
      SePopupContentComponent
  ]
})
export class SeUiLayoutModule { }
